<template>
    <div class="modal is-active"  >
        <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
 
              <button class="delete" aria-label="close"   @click="closeBtn" ></button>
               <h1 class="has-text-grey is-size-5 ml-4">Penquin Dialog</h1>
<!-- {{dataProps1}} -->
            </header>

            <section class="modal-card-body">
                <article>



                    <b-field grouped group-multiline>


                        <div class="control">
                            <b-taglist attached>
                                <b-tag type="is-light" class="has-text-grey-darker is-size-6 tag-border-header">Lab No.</b-tag>
                                <b-tag type="is-warning is-light" class="has-text-grey-dark is-size-6 tag-border-data">{{dataProps1.idlab}}</b-tag>
                            </b-taglist>

                        </div>



                        <div class="control">
                            <b-taglist attached>
                                <b-tag type="is-light" class="has-text-grey-darker is-size-6 tag-border-header">OPD No.</b-tag>
                                <b-tag type="is-warning is-light" class="has-text-grey-dark is-size-6 tag-border-data">{{dataProps1.idopd}}</b-tag>
                            </b-taglist>

                        </div>

                        <div class="control">
                            <b-taglist attached>
                                <b-tag type="is-light" class="has-text-grey-darker is-size-6 tag-border-header">Pet Name</b-tag>
                                <b-tag type="is-warning is-light"  class="has-text-grey-dark is-size-6 tag-border-data">{{dataProps1.opdname}}</b-tag>
                            </b-taglist>
                        </div>


                        <div class="control">
                            <b-taglist attached>
                                <b-tag type="is-light" class="has-text-grey-darker is-size-6 tag-border-header">Owner</b-tag>
                                <b-tag type="is-warning is-light"  class="has-text-grey-dark is-size-6 tag-border-data">{{dataProps1.owner_name}}</b-tag>
                            </b-taglist>
                        </div>


                        <div class="control">
                            <b-taglist attached>
                                <b-tag type="is-light" class="has-text-grey-darker is-size-6 tag-border-header">Gender</b-tag>
                                <b-tag type="is-warning is-light"  class="has-text-grey-dark is-size-6 tag-border-data">
                                    <b-icon
                                            :icon="dataProps1.gender === 'M' ? 'gender-male' : 'gender-female'">
                                    </b-icon>

                                </b-tag>
                            </b-taglist>
                        </div>


                        <div class="control">
                            <b-taglist attached>
                                <b-tag type="is-light" class="has-text-grey-darker is-size-6 tag-border-header">Age</b-tag>
                                <b-tag type="is-warning is-light"  class="has-text-grey-dark is-size-6 tag-border-data">{{dataProps1.age}}</b-tag>
                            </b-taglist>
                        </div>


                        <div class="control">
                            <b-taglist attached>
                                <b-tag type="is-light" class="has-text-grey-darker is-size-6 tag-border-header">Species</b-tag>
                                <b-tag type="is-warning is-light" class="has-text-grey-dark is-size-6 tag-border-data">{{dataProps1.type}}</b-tag>
                            </b-taglist>
                        </div>





                    </b-field>



                </article>
                <hr>


                <b-tabs v-model="activeTab"  >
                    <b-tab-item label="Main">
                        <div class="tile is-ancestor has-text-centered">
                            <div class="tile is-parent">
                                <article class="tile is-child ">
                                    <b-button size="is-medium"
                                              icon-left="printer"
                                              type="is-primary" outlined
                                              @click="printStickerLab(1)"
                                    >
                                        Print LN
                                    </b-button>
                                </article>
                            </div>
                            <div class="tile is-parent">
                                <article class="tile is-child ">
                                    <b-button size="is-medium"
                                              icon-left="printer"
                                              type="is-primary" outlined
                                              @click="printStickerLab(2)"
                                    >
                                        Print HN
                                    </b-button>
                                </article>
                            </div>





                        </div>


<!--                        <div class="tile is-ancestor has-text-centered">-->
<!--                            <div class="tile is-parent">-->
<!--                                <article class="tile is-child ">-->
<!--                                    <b-button size="is-medium"-->
<!--                                              icon-left="check"-->
<!--                                              type="is-success" outlined-->
<!--                                              :disabled="!checkAuthButton('accept')"-->
<!--                                              @click="actionPoodle(1)"-->
<!--                                    >-->
<!--                                        Accept-->
<!--                                    </b-button>-->
<!--                                </article>-->
<!--                            </div>-->
<!--                            <div class="tile is-parent">-->
<!--                                <article class="tile is-child ">-->
<!--                                    <b-button size="is-medium"-->
<!--                                              icon-left="alert-circle-outline"-->
<!--                                              type="is-danger" outlined-->
<!--                                              :disabled="!checkAuthButton('reject')"-->
<!--                                              @click="actionPoodle(3)"-->
<!--                                    >-->
<!--                                        Reject-->
<!--                                    </b-button>-->
<!--                                </article>-->
<!--                            </div>-->

<!--                        </div>-->


<!--                        <div class="tile is-ancestor has-text-centered">-->
<!--                            <div class="tile is-parent">-->
<!--                                <article class="tile is-child ">-->
<!--                                    <b-button size="is-medium"-->
<!--                                              icon-left="cancel"-->
<!--                                              type="is-danger" outlined-->
<!--                                              :disabled="!checkAuthButton('cancel')"-->
<!--                                              @click="actionPoodle(2)"-->
<!--                                    >-->
<!--                                        Cancel-->
<!--                                    </b-button>-->
<!--                                </article>-->
<!--                            </div>-->
<!--                            <div class="tile is-parent">-->

<!--                            </div>-->

<!--                        </div>-->

                        <article>

                            <hr>

                            <b-table
                                    :data="isEmpty ? [] : dataUsedPart"
                                    bordered
                                    striped
                                    hoverable
                                    focusable
                                    mobile-cards>


                                <b-table-column   label="รหัส" v-slot="props">
                                    {{ props.row.idpart }}
                                </b-table-column>

                                <b-table-column  label="รายการ" v-slot="props">
                                    {{ props.row.partdecp }}
                                </b-table-column>

                                <b-table-column   label="จำนวน" v-slot="props">
                                    {{ props.row.amount }}
                                </b-table-column>

                                <b-table-column   label="หน่วยนับ" v-slot="props">
                                    {{ props.row.unit_part }}
                                </b-table-column>

                                <b-table-column   label="สถานะ" v-slot="props">
                                    <b-icon
                                            :icon="props.row.status   ? 'check' : 'close-thick'"
                                            :type="props.row.status   ? 'is-success' : 'is-danger'">
                                    </b-icon>
                                </b-table-column>



                                <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                        icon="emoticon-sad"
                                                        size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                                </template>
                            </b-table>




                        </article>

                    </b-tab-item>
                    <b-tab-item label="Preview">
                        <iframe      :src="dataIFrame" frameborder="0"   width="100%" height="400px"/>
                    </b-tab-item>
                </b-tabs>








<!--                <div class="columns">-->
<!--                    <div class="column">-->
<!--                            <b-button type="is-primary is-light" >Primary Light</b-button>-->
<!--                    </div>-->
<!--                    <div class="column">-->
<!--                            <b-button type="is-primary is-light">Primary Light</b-button>-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class="columns">-->
<!--                    <div class="column">-->
<!--                        <div class="box"><b-button type="is-primary is-light">Primary Light</b-button></div>-->
<!--                    </div>-->
<!--                    <div class="column">-->
<!--                        <div class="box"><b-button type="is-primary is-light">Primary Light</b-button></div>-->
<!--                    </div>-->
<!--                </div>-->

            </section>
            <footer class="modal-card-foot" style="justify-content: space-between;">


                <b-button type="is-danger"
                          icon-right="close"
                          @click="closeBtn" >Cancel</b-button>


                <b-field >


                    <b-tag
                           close-type='is-warning'
                           close-icon-type='is-dark'
                           attached
                           :closable="checkAuthButtonHold"
                           close-icon='delete'
                           aria-close-label="Close tag"
                           size="is-large"
                           @close="turnOnOffHold('off')"
                           v-if="dataProps1.hold" >
                        Hold
                    </b-tag>



                    <p class="control" v-if="!dataProps1.hold">
                        <b-button type="is-success " label="Hold"
                                  :disabled="!checkAuthButtonHold"
                                  @click="turnOnOffHold('on')"/>
                    </p>

                </b-field>
            </footer>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import { getBaseURLforBackEnd , getConfigAxios ,CALL_FROM  } from '@/utils.js'
    import { mapState} from "vuex";
    import userRoleFind from "../../mixins/methods/userRoleFind";
 
    export default {
        name: "DialogOperations",
        props:{
            dataProps1:Object,
            isDialogOperations : Boolean
        },
        mixins:[userRoleFind],
        created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.closeBtn()

                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
        },

        computed:{
            ...mapState({
                access_token: state => state.master_data.access_token,
                user_role: state => state.master_data.user_role,
                userIsAdmin: state => state.master_data.userIsAdmin,
                user_id: state => state.master_data.user_id,
            }) ,

            checkAuthButtonHold(){


                if(this.userIsAdmin){
                    return true
                } else{
                    return  this.userRoleFind(9)
                }


            }
        },
        methods:{

            checkAuthButton(_button){

                //
                if(_button === 'accept'){
                    if(this.userIsAdmin){
                        return  true
                    }else{
                      return this.userRoleFind(7)
                    }
                }


                //
                if(_button === 'reject'){
                    if(this.userIsAdmin){
                        return  true
                    }else{
                        return this.userRoleFind(8)
                    }
                }



                //
                if(_button === 'cancel'){
                    if(this.userIsAdmin){
                        return  true
                    }else{
                        return this.user_id === this.dataProps1.user_req_id
                    }
                }








                return false
            },
            turnOnOffHold(on_off){
                const datTo = {
                    "idlab": this.dataProps1.idlab ,
                    "hold": on_off ==='on' ? true : false
                }

                this.isFullScreenSearching = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/poodle_hold`,datTo,getConfigAxios())
                    .then(()=>{
                        // console.log(res.data)
                        this.dataProps1.hold =   on_off ==='on'  ?  '1' : null
                        this.isFullScreenSearching = false
                        this.$emit('changeHoldStatus',datTo)
                    })

                    .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.response.data.msg} `,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        this.isFullScreenSearching = false
                    })
            },



            actionPoodleReal(_idaction,valueTxt,careValueTxt){   // careValueTxt now for accept only
                const datTo = {
                    "idlab":  this.dataProps1.idlab ,
                    "action": _idaction ,
                    "valuetxt" :      (valueTxt == null || valueTxt == "") ? "" : valueTxt ,
                    "care_txt" :   careValueTxt
                }
                // console.log(JSON.stringify(datTo))
                this.isFullScreenSearching = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/poodle_action_lab`,datTo,getConfigAxios())
                    .then((res)=>{
                        this.$buefy.toast.open({
                            duration: 1000,
                            message: `${res.data.msg}  `,
                            position: 'is-bottom',
                            type: 'is-success'
                        })
                        this.closeWithChange(datTo)
                        this.isFullScreenSearching = false
                    })
                    .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.response.data.msg} `,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        this.isFullScreenSearching = false
                    })
            },

            actionPoodle(_idaction){
                // console.log(_idaction)
               //1 === accept    2 === cancel  3 === reject
               if(_idaction === 1){
                   this.$buefy.dialog.prompt({
                       message: `Input Ref1`,
                       inputAttrs: {
                           placeholder: 'e.g. 1111',
                           maxlength: 10,
                           required: false

                       },
                       trapFocus: false,
                       onConfirm: (value) => this.actionPoodleReal(_idaction,value,true)
                   })

               }else{
                   var TXT = ""

                   if(_idaction === 2){
                       TXT = "Cancel"
                   }
                   if(_idaction === 3){
                       TXT = "Reject"
                   }
                   this.$buefy.dialog.confirm({
                       title: 'Confirm ?',
                       message: `Are you sure you want to <b>${TXT}</b> ? This action cannot be undone.`,
                       confirmText: 'Continue',
                       type: 'is-danger',
                       hasIcon: true,
                       onConfirm: () =>   this.actionPoodleReal(_idaction,"",false)
                   })

               }







            },


            printStickerLab(_kind){

                this.isFullScreenSearching = true


                var ENDPOINT = ""
                var datTo ={}


                if (_kind===1){
                    // ENDPOINT = "makelabel_ln_cbc"
                    ENDPOINT = "makelabel_ln_cbc_v2"
                    datTo =JSON.parse(JSON.stringify({
                        "idlab" : this.dataProps1.idlab
                    }))

                }else if(_kind===2){
                    ENDPOINT = "make_label_opd"
                    datTo =JSON.parse(JSON.stringify({
                        "ref_no" : this.dataProps1.ref_no
                    }))
                }


                // console.log(JSON.stringify(datTo))  
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/${ENDPOINT}`,datTo,getConfigAxios())
                    .then((res)=>{
                        if(CALL_FROM == 1){  // 0 == labpatho.vet.ku.ac.th , 1 == local(172.16.2.116) , 2 == https://kuvdl.vet.ku.ac.th   
                                this.dataIFrame = res.data.url_local
                        }else{
                                this.dataIFrame = res.data.url  
                        }
                        this.activeTab = 1
                        this.isFullScreenSearching = false
                    })
                    .catch((err)=>{
                        this.$buefy.toast.open({
                            duration: 4000,
                            message: `${err.response.data.msg}  ${err.response.data.detail}`,
                            position: 'is-bottom',
                            type: 'is-danger'
                        })
                        this.isFullScreenSearching = false
                    })



            },
            loadUsedPart(){
                const datTo ={
                    "idlab" : this.dataProps1.idlab
                }
                const endPoint = this.dataProps1.patho_job != null  ? 'orderlabrequestcbc_detailfromidlab_pathoservices' : 'orderlabrequestcbc_detailfromidlab'  
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/${endPoint}`,datTo,getConfigAxios())
                   .then((res)=>{
                         this.dataUsedPart = res.data
                   })
                   .catch((err)=>{
                       this.$buefy.toast.open({
                           duration: 4000,
                           message: `${err.response.data.msg}  ${err.response.data.detail}`,
                           position: 'is-bottom',
                           type: 'is-danger'
                       })
                   })

            },
            closeBtn(){
               this.$emit('close')
            },
            closeWithChange(payload){
                this.$emit('closeWithChange',payload)
            }

        },
        data(){
            return{
                dataUsedPart :[],
                isEmpty : false,
                isFullScreenSearching : false,
                activeTab : 1,
                dataIFrame : "",
            }
        },
        watch:{
            isDialogOperations:{
                immediate : true,
                handler : function (val) {
                      if(val){
                          this.loadUsedPart()
                          this.activeTab = 0
                      }
                }
            }
        }
    }
</script>

<style scoped>
    .container {
        height: 200px;
        position: relative;
        border: 3px solid green;
    }

    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }



    .tag-border-header{
        border:1px solid #00b89c;
    }
    .tag-border-data{
        border-bottom :1px solid #00b89c;
        border-right:1px solid #00b89c;
        border-top:1px solid #00b89c;
    }



</style>